
import * as net from "./network/net";
import BonusRoulette from './bonus_roulette';
const network = require( "./network/network_api" );

export default function(
    $state,
    $request,
    view,
    $start,
    parent,
)
{
    const space = parent.child( "roulette" );
    
    const $preview = $state
        .map( function( state )
        {
            if ( state.type != network.TYPE.PRECURSOR ) return undefined;
            return state.state.way_map.find( avail => avail == network.TYPE.PRECURSOR ) ? state : undefined;
        } )
        .distinctUntilChanged( _.isEqual );
    
    const $play = $state
        .map( function( state )
        {
            if ( state.type != network.TYPE.PRECURSOR ) return undefined;
            return state.state.way_map.find( avail => avail != network.TYPE.PRECURSOR ) ? state : undefined;
        } )
        .distinctUntilChanged( _.isEqual );
    
    const $jackpot = $state
        .map( state => state.type == network.TYPE.JACKPOT ? state : undefined )
        .distinctUntilChanged( _.isEqual );
    
    const $hide = $state
        .map(
            state => state.type != network.TYPE.PRECURSOR
            &&
            (
                state.type != network.TYPE.JACKPOT
                ||
                //if no "bonusTypeId" then it's jackpot on it's own (without precursing roulette):
                ! state.state.stage.math.bonusTypeId
            )
        )
        .distinctUntilChanged()
        .filter( hide => hide === true );
    
    const $startRotate = space.s( "startRotate" );
    
    const roulette = BonusRoulette(
        $preview.filter( state => state !== undefined ),
        $startRotate,
        $play.filter( state => state !== undefined ),
        $jackpot.filter( state => state !== undefined ),
        $hide,
        view
    );
    
    //proceed to next state when roulette finished it's rotation animation:
    roulette.$animating
        .pair()
        .filter( ([ was, now ]) => was && ! now )
        .withLatestFrom( $play, ( a, play ) => play )
        .filter( play => play !== undefined )
        .map( () => ( { type : net.REQUEST_TYPE.PROCEED } ) )
        .subscribe( $request );
    
    $start
        .withLatestFrom( $preview, ( start, preview ) => preview )
        .filter( preview => preview !== undefined )
        .map( () => ( { type : net.REQUEST_TYPE.ROULETTE } ) )
        .subscribe( request =>
        {
            console.log( "Starting roulete spin ..." );
            $startRotate.next();
            $request.next( request );
        } );
    
    return {
        $animating : roulette.$animating,
        $startImpulse : roulette.$startImpulse,
    };
}





// WEBPACK FOOTER //
// ./src/library/roulette_driver.es6